import { useSelector } from "react-redux";
import { useFormContext } from "react-hook-form";
import { selectCart } from "@/store/redux";
import { Donate } from "./Donate";
import { TotalWrapper, TotalDesc, TotalValue } from "./Total.styled";

export function Total() {
  const { watch } = useFormContext();
  const { ptotal, old_total } = useSelector(selectCart);

  const donate = watch("donate");
  const hasSale = ptotal < old_total;

  return (
    <>
      <Donate />

      <TotalWrapper sx={{ display: "flex" }}>
        Total:
        <TotalValue>$ {ptotal + donate}</TotalValue>
        {hasSale && (
          <TotalValue>
            <s>$ {old_total + donate}</s>
          </TotalValue>
        )}
      </TotalWrapper>
      <TotalWrapper sx={{ display: "flex", fontSize: "1.5rem" }}>
        Donation:
        <TotalValue>$ {donate || 0}</TotalValue>
      </TotalWrapper>
      <TotalDesc>
        This total doesn't include delivery. The sum of product and delivery
        cost is going to be deducted from your monthly compensation and donated
        to the Bright Volunteers fund.
      </TotalDesc>
    </>
  );
}
